import axios from "axios";

async function FetchWeather(coordinates) {
  const response = await axios.get(
    "https://api.openweathermap.org/data/2.5/onecall?",
    {
      params: {
        lat: coordinates.lat,
        lon: coordinates.lng,
        exclude: "minutely,hourly,alerts",
        appid: "29edd68bdf83aeb61bda70225ccd1093",
        units: "metric",
      },
    }
  );

  return response;
}

export default FetchWeather;
